/* afzuigkapSpecialist.nl: chat-icoon in de header (naast account en winkelwagen) dat de Shopify Inbox-chat opent.
   De zwevende standaardknop van Inbox wordt verborgen zodra het icoon werkt. Zonder Inbox blijft het icoon weg. */
(function () {
  if (window.WAVE_HEADER_CHAT) return;
  window.WAVE_HEADER_CHAT = 1;
  var SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.45" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M5 3.75h14A2.75 2.75 0 0 1 21.75 6.5v8.5A2.75 2.75 0 0 1 19 17.75h-8.2l-4.55 3.4v-3.4H5A2.75 2.75 0 0 1 2.25 15V6.5A2.75 2.75 0 0 1 5 3.75Z"/><circle cx="7.75" cy="10.75" r="1.05" fill="currentColor" stroke="none"/><circle cx="12" cy="10.75" r="1.05" fill="currentColor" stroke="none"/><circle cx="16.25" cy="10.75" r="1.05" fill="currentColor" stroke="none"/></svg>';
  function chat() { return document.querySelector('shopify-chat'); }
  function isOpen(c) { return c.hasAttribute('open'); }
  function toggle(e) {
    if (e) e.preventDefault();
    var c = chat(); if (!c) return;
    try {
      if (isOpen(c)) { if (typeof c.close === 'function') c.close(); else c.removeAttribute('open'); }
      else { if (typeof c.show === 'function') c.show(); else c.setAttribute('open', ''); }
    } catch (err) {
      var b = c.shadowRoot && c.shadowRoot.querySelector('button.activator, [part~="activator"] button, button');
      if (b) b.click();
    }
    sync();
  }
  function sync() {
    var c = chat();
    [].slice.call(document.querySelectorAll('.wave-chat-btn')).forEach(function (b) { b.setAttribute('aria-expanded', c && isOpen(c) ? 'true' : 'false'); });
  }
  function css() {
    if (document.getElementById('wave-chat-css')) return;
    var s = document.createElement('style'); s.id = 'wave-chat-css';
    s.textContent = '.wave-chat-btn{background:none;border:0;color:inherit;cursor:pointer;font:inherit;line-height:0;-webkit-appearance:none;appearance:none}' +
      '.wave-chat-btn .icon{display:block;width:24px;height:24px}' +
      'html.wave-chat-on shopify-chat::part(activator){display:none!important}' +
      /* mobiel: vier iconen naast het logo; iconen iets smaller en logo-formule aangepast zodat het logo op een regel blijft */
      '@media (max-width:768px){html.wave-chat-on .header__icons .header__icon{padding-left:7px;padding-right:7px;width:38px;min-width:0}' +
      'html.wave-chat-on .header__logo .logo__text{font-size:clamp(12px,calc((100vw - 232px) / 10),20px)!important}}' +
      '@media (max-width:359px){html.wave-chat-on .header__logo .logo__text{font-size:clamp(11px,calc((100vw - 200px) / 10),16px)!important}}';
    document.head.appendChild(s);
  }
  function add() {
    var c = chat(); if (!c) return false;
    var cart = document.getElementById('cart-icon');
    if (!cart || !cart.parentNode) return false;
    if (cart.parentNode.querySelector('.wave-chat-btn')) return true;
    css();
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'header__icon wave-chat-btn';
    b.setAttribute('aria-label', 'Chat met ons');
    b.setAttribute('aria-expanded', 'false');
    b.setAttribute('title', 'Chat met ons');
    b.innerHTML = SVG + '<span class="visually-hidden">Chat met ons</span>';
    b.addEventListener('click', toggle);
    cart.parentNode.insertBefore(b, cart);
    document.documentElement.classList.add('wave-chat-on');
    try { new MutationObserver(sync).observe(c, { attributes: true, attributeFilter: ['open'] }); } catch (e) { }
    return true;
  }
  function boot() {
    if (add()) return;
    var n = 0, t = setInterval(function () { if (add() || ++n > 40) clearInterval(t); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
